import React from 'react';

import "./Footer.css"
const Footer = () => {
    return (
        <div className="footerStyle">
            <small>&copy; All rights reserved</small>
         
        </div>
    );
};

export default Footer;